import React from 'react';

import { Text } from '@lp/ds-next';
import { Flex } from 'antd';

import { reasonEnum } from '.';

export const ErrorText = ({ data }: { data: Record<string, boolean> }) => (
  <Flex vertical>
    <Text variant="bodyTextM" color="custom.error.red.100">
      Organisation is in the middle of closure procedure. In order to close it
      definitively, please be sure that :
      <ul style={{ marginLeft: '1.5rem', listStyleType: 'disc' }}>
        {data[reasonEnum.UNPAID_BILLS] && <li>all bills are paid</li>}
        {data[reasonEnum.PRODUCTS] && (
          <li>all BOXes & tablets are returned to LP office</li>
        )}
        {data[reasonEnum.LITIGATIONS] && (
          <li>no shipments are left “in litigation”</li>
        )}
      </ul>
    </Text>
  </Flex>
);
